import { useQuery } from "@tanstack/react-query";

import { CLIENT_KEYS } from "../../constants/clientKeys";
import { callApi } from "../../utils/callApi";

type Tag = {
  id: string;
  name: string;
  created_at: string;
};

export const useTags = () => {
  return useQuery({
    queryKey: [CLIENT_KEYS.TAGS],
    queryFn: async (): Promise<Tag[]> => {
      const data = await callApi("tags/", "GET");
      return data as Tag[];
    },
  });
};
